<nz-layout>
  @if (!addScreen) {
    <nz-header class="section-header">
      <div fxLayout="row">
        <div fxLayout="col" fxFlex="30">
          {{ "Medication Summary" | translate }}
        </div>
        <div fxLayout="col" fxFlex="70" fxLayoutAlign="end center">
          @if ((isEOC() || isInpatientView()) && hasPermission(['a-med'])) {
            <button nz-button nzPrimary
              style="float: right" class="add-medication-btn" type="button" (click)="handleButton()">
              <i nz-icon nzType="icons:plus" nzTheme="outline"></i>
              {{ "Add Medication" | translate }}
            </button>
          }
        </div>
      </div>
    </nz-header>
  }
  <nz-content>
    @if (!addScreen) {
      <div>
        @for (cm of submenu; track cm) {
          @if (cm.path == componentPaths.currentMedicines) {
            <app-current-medication [id]="cm.path" />
          }
          @if (cm.path == componentPaths.pastMedicines) {
            <app-past-medication [id]="cm.path" />
          }
        }
      </div>
    }
    @if (addScreen) {
      <app-medication-add />
    }
  </nz-content>
</nz-layout>